import { defineMessages } from '@/i18n';

export const artistsMessages = defineMessages({
  pageTitle: 'platform.app.invitations.artists',
  newArtist: 'platform.app.artists.newArtist',
  deleteDialogTitle: 'platform.app.artists.deleteDialogTitle',
  listingColumnArtist: 'platform.app.artists.listing.columns.artist',
  listingColumnGalleries: 'platform.app.artists.listing.columns.galleries',
  listingColumnTags: 'platform.app.artists.listing.columns.tags',
  listingFilterBasedIn: 'platform.app.artists.listing.filters.basedIn',
  listingFilterNationality: 'platform.app.artists.listing.filters.nationality',
  listingFilterGender: 'platform.app.artists.listing.filters.gender',
  listingFilterAge: 'platform.app.artists.listing.filters.age',
  listingFilterLabel: 'platform.app.artists.listing.filters.label',
  listingFilterUnknown: 'platform.app.artists.listing.filters.unknown',
  listingSortNewestFirst: 'platform.app.artists.listing.sort.newestFirst',
  listingSortOldestFirst: 'platform.app.artists.listing.sort.oldestFirst',
  listingMetaBornPrefix: 'platform.app.artists.listing.meta.bornPrefix',
  listingMetaBasedInPrefix: 'platform.app.artists.listing.meta.basedInPrefix',
  listingGalleriesLoadError: 'platform.app.artists.listing.galleriesLoadError',
  mergeDialogTitle: 'platform.app.artists.merge.dialogTitle',
  mergeFilterPlaceholder: 'platform.app.artists.merge.filterPlaceholder',
  mergeNoteTitle: 'platform.app.artists.merge.noteTitle',
  mergeNoteDescription: 'platform.app.artists.merge.noteDescription',
  mergeWarning: 'platform.app.artists.merge.warning',
  mergeConfirmationTitle: 'platform.app.artists.merge.confirmationTitle',
  mergeConfirmationMessage: 'platform.app.artists.merge.confirmationMessage',
  mergeSuccessMessage: 'platform.app.artists.merge.successMessage',
  websiteLabel: 'platform.app.artists.socialLinks.websiteLabel',
  instagramLabel: 'platform.app.artists.socialLinks.instagramLabel',
  artsyLabel: 'platform.app.artists.socialLinks.artsyLabel',
  artnetLabel: 'platform.app.artists.socialLinks.artnetLabel',
  twitterLabel: 'platform.app.artists.socialLinks.twitterLabel',
  youtubeLabel: 'platform.app.artists.socialLinks.youtubeLabel',
  vimeoLabel: 'platform.app.artists.socialLinks.vimeoLabel',
  facebookLabel: 'platform.app.artists.socialLinks.facebookLabel',
  tiktokLabel: 'platform.app.artists.socialLinks.tiktokLabel',
  linkedinLabel: 'platform.app.artists.socialLinks.linkedInLabel',
  wechatLabel: 'platform.app.artists.socialLinks.wechatLabel',
  xiaohongshuLabel: 'platform.app.artists.socialLinks.xiaohongshuLabel',
  wikipediaLabel: 'platform.app.artists.socialLinks.wikipediaLabel',
  otherLabel: 'platform.app.artists.socialLinks.otherLabel',
  nameLabel: 'platform.app.artists.socialLinks.nameLabel',
  urlLabel: 'platform.app.artists.socialLinks.urlLabel',
  urlPlaceholder: 'platform.app.artists.socialLinks.urlPlaceholder',
  invalidUrl: 'platform.app.artists.socialLinks.invalidUrl',
  invalidPlatform: 'platform.app.artists.socialLinks.invalidPlatform',
  invalidUrlInstagram: 'platform.app.artists.socialLinks.errors.invalidInstagram',
  invalidUrlFacebook: 'platform.app.artists.socialLinks.errors.invalidFacebook',
  invalidUrlArtsy: 'platform.app.artists.socialLinks.errors.invalidArtsy',
  invalidUrlArtnet: 'platform.app.artists.socialLinks.errors.invalidArtnet',
  invalidUrlTwitter: 'platform.app.artists.socialLinks.errors.invalidTwitter',
  invalidUrlYoutube: 'platform.app.artists.socialLinks.errors.invalidYoutube',
  invalidUrlVimeo: 'platform.app.artists.socialLinks.errors.invalidVimeo',
  invalidUrlLinkedin: 'platform.app.artists.socialLinks.errors.invalidLinkedIn',
  invalidUrlTiktok: 'platform.app.artists.socialLinks.errors.invalidTiktok',
  invalidUrlWechat: 'platform.app.artists.socialLinks.errors.invalidWechat',
  invalidUrlXiaohongshu: 'platform.app.artists.socialLinks.errors.invalidXiaohongshu',
  invalidUrlWikipedia: 'platform.app.artists.socialLinks.errors.invalidWikipedia',
  urlPlaceholderInstagram: 'platform.app.artists.socialLinks.placeholders.instagram',
  urlPlaceholderFacebook: 'platform.app.artists.socialLinks.placeholders.facebook',
  urlPlaceholderArtsy: 'platform.app.artists.socialLinks.placeholders.artsy',
  urlPlaceholderArtnet: 'platform.app.artists.socialLinks.placeholders.artnet',
  urlPlaceholderYoutube: 'platform.app.artists.socialLinks.placeholders.youtube',
  urlPlaceholderTwitter: 'platform.app.artists.socialLinks.placeholders.twitter',
  urlPlaceholderVimeo: 'platform.app.artists.socialLinks.placeholders.vimeo',
  urlPlaceholderLinkedin: 'platform.app.artists.socialLinks.placeholders.linkedin',
  urlPlaceholderTiktok: 'platform.app.artists.socialLinks.placeholders.tiktok',
  urlPlaceholderWechat: 'platform.app.artists.socialLinks.placeholders.wechat',
  urlPlaceholderXiaohongshu: 'platform.app.artists.socialLinks.placeholders.xiaohongshu',
  urlPlaceholderWikipedia: 'platform.app.artists.socialLinks.placeholders.wikipedia',
  requiredFieldError: 'platform.app.validation.required',
});

export const artistProfileMessages = defineMessages({
  pageTitleStatic: 'platform.app.artistProfile.pageTitleStatic',
  galleriesTitle: 'platform.app.artistProfile.galleries',
  artworksTitle: 'platform.app.artistProfile.artworks',
  noArtworksTitle: 'platform.app.artistProfile.noArtworks',
  logsTitle: 'platform.app.artistProfile.logs',
});

export const newArtistMessages = defineMessages({
  formTitle: 'platform.app.artists.create.formTitle',
  formSubtitle: 'platform.app.artists.create.formSubtitle',
  //
  fieldNameLabel: 'platform.app.artists.create.formFields.name.label',
  fieldNameHint: 'platform.app.artists.create.formFields.name.hint',
  fieldSurnameLabel: 'platform.app.artists.create.formFields.surname.label',
  fieldNameNativeLabel: 'platform.app.artists.create.formFields.nameNative.label',
  fieldNameNativeHint: 'platform.app.artists.create.formFields.nameNative.hint',
  fieldBirthYearLabel: 'platform.app.artists.create.formFields.birthYear.label',
  fieldDeathYearLabel: 'platform.app.artists.create.formFields.deathYear.label',
  fieldDeathYearHint: 'platform.app.artists.create.formFields.deathYear.hint',
  fieldNationalityLabel: 'platform.app.artists.create.formFields.nationality.label',
  fieldCityOfBirthLabel: 'platform.app.artists.create.formFields.cityOfBirth.label',
  fieldGenderLabel: 'platform.app.artists.create.formFields.gender.label',
  fieldGenderOptionMale: 'platform.app.artists.create.formFields.genderOptionsMale',
  fieldGenderOptionFemale: 'platform.app.artists.create.formFields.genderOptionsFemale',
  fiendCountryOfResidenceLabel: 'platform.app.artists.create.formFields.countryOfResidence.label',
  fieldCityOfResidenceLabel: 'platform.app.artists.create.formFields.cityOfResidence.label',
  fieldTagsLabel: 'platform.app.artists.create.formFields.tags.label',
  fieldTagsCta: 'platform.app.artists.create.formFields.tags.dropdownCta',
  fieldWebsiteLabel: 'platform.app.artists.create.formFields.website.label',
  fieldWebsitePlaceholder: 'platform.app.artists.create.formFields.website.placeholder',
  fieldInstagramLabel: 'platform.app.artists.create.formFields.instagram.label',
  fieldArtsyLabel: 'platform.app.artists.create.formFields.artsy.label',
  fieldArtnetLabel: 'platform.app.artists.create.formFields.artnet.label',
  fieldFreeformUrlPlaceholder: 'platform.app.artists.create.formFields.freeformUrlSelect.placeholder',
  //
  fieldIsRequired: 'platform.app.artists.create.formFields.errors.genericEmpty',
  mustBeAYear: 'platform.app.artists.create.formFields.errors.notAYear',
  mustBeAfterBirth: 'platform.app.artists.create.formFields.errors.deathNotAfterBirth',
  mustBeBeforeDeath: 'platform.app.artists.create.formFields.errors.birthNotBeforeDeath',
  unknownNationality: 'platform.app.artists.create.formFields.errors.nationalityNotInList',
  tagTooLong: 'platform.app.artists.create.formFields.errors.tagTooLong',
  //
  toastSuccessTitle: 'platform.app.artists.create.toastSuccessTitle',
  toastSuccessMessage: 'platform.app.artists.create.toastSuccessMessage',
  toastErrorTitle: 'platform.app.artists.create.toastErrorTitle',
  toastErrorMessage: 'platform.app.artists.create.toastErrorMessage',
});

export const artworkDetailsMessages = defineMessages({
  fairsAndFirstLooks: 'platform.app.artistProfile.fairsAndFirstLooks',
  fairs: 'platform.app.artistProfile.fairs',
});

export const editArtistMessages = defineMessages({
  documentTitle: 'platform.app.artists.edit.documentTitle',
  pageTitle: 'platform.app.artists.edit.pageTitle',
  toastTitleSuccess: 'platform.app.artists.edit.toastSuccessTitle',
  toastMessageSuccess: 'platform.app.artists.edit.toastSuccessMessage',
  toastTitleError: 'platform.app.artists.edit.toastErrorTitle',
  toastMessageError: 'platform.app.artists.edit.toastErrorMessage',
});
